import type { RenderFilter } from "./types";
import { useCrmTrueLocationFieldAndSearchEnabled } from "./useCrmLocationEnabled";

export const useShouldShowNearMeFilter = (filters: RenderFilter[]) => {
  const isCrmTrueLocationFieldAndSearchEnabled =
    useCrmTrueLocationFieldAndSearchEnabled();

  if (isCrmTrueLocationFieldAndSearchEnabled) {
    return filters;
  }

  return filters.filter(filter => filter.name !== "near_me");
};
